import {
  Text,
} from '@chakra-ui/react';
import {
  useLengthVsVKT,
} from '@src/modules/performance/context/reports-api-hooks';
import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Journey Distribution - ONF Street Categories',
  content: [
    {
      title: 'Length vs VKT (ONF Street Categories)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The distribution of vehicle kilometres travelled and network length for the financial year, summarised by ONF Street Categories.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Road Efficiency Group Te Ringa Maimoa has calculated this result.
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from the ONF classifications and traffic volumes recorded in AWM.
  </Text>,
    },
  ],
};

function RoadNetworkUseJourneyDistributionStreetCategory() {
  const { data: lengthVsVktOnf, isLoading: isLoadingLengthOnf } = useLengthVsVKT('streetCategory');
  const isLoading = isLoadingLengthOnf;

  // ONF Chart
  const lengthVsVktOnfData = [
    {
      name: 'Length %',
      type: 'bar',
      data: lengthVsVktOnf?.map((item) => ({
        x: item.Category,
        y: item.PercTotalKm > 0.5 ? item.PercTotalKm * -1 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Vehicle kilometres travelled %',
      type: 'bar',
      data: lengthVsVktOnf?.map((item) => ({
        x: item.Category,
        y: item.PercTotalVKT > 0.5 ? item.PercTotalVKT : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Journey Distribution - ONF Street Categories"
      isLoading={isLoading || !lengthVsVktOnf}
      informationSource={informationSource}
      lockYear={lengthVsVktOnf?.[0]?.LockYear}
    >
      <TornadoBarChart
        title="Length vs VKT (ONF Street Categories)"
        categories={[...new Set(lengthVsVktOnf?.map((item) => item.Category))]}
        series={lengthVsVktOnfData}
        dataLabelFormatter={(val) => {
          if (val === 0) {
            return '';
          }
          const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
          return labelFormatted;
        }}
        suffix="%"
      />
    </ReportSection>
  );
}

export default RoadNetworkUseJourneyDistributionStreetCategory;
